import { useLayoutEffect, useMemo, useRef } from 'react';
import {
    useTimelineDispatch,
    useTimelineInterval,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';
import { TimelineAxisLabel } from './TimelineAxisLabel';
import { TimelineNowIndicator } from './TimelineNowIndicator';

import './TimelineAxis.scss';

export function TimelineAxis() {
    const timelineInterval = useTimelineInterval();
    const { getAxisSections } = useTimelineViewMode();
    const { setPixelWidth } = useTimelineDispatch();
    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (!ref.current) return;
        const { width } = ref.current.getBoundingClientRect();
        if (width === 0) return;
        setPixelWidth(width);
    }, [setPixelWidth]);

    return useMemo(
        () => (
            <div ref={ref} className="TimelineAxis">
                <TimelineNowIndicator />
                {getAxisSections(timelineInterval).map((timestamp) => (
                    <TimelineAxisLabel key={timestamp.toLocaleString()} timestamp={timestamp} />
                ))}
            </div>
        ),
        [timelineInterval, getAxisSections],
    );
}
